function exposeBootstrapFailure(caught: unknown): void {
  const root = document.getElementById("root");
  if (root === null) return;
  const message = caught instanceof Error
    ? caught.message
    : "UNKNOWN_APPLICATION_BOOTSTRAP_FAILURE";
  const safeMessage = message
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;");
  root.innerHTML = `
    <div role="alert" style="box-sizing:border-box;display:grid;min-height:100dvh;padding:8vw;background:#080d14;color:#dce8f2;font:700 14px/1.5 ui-monospace,monospace;place-items:center">
      <div style="width:min(46rem,100%);padding:2rem;border:1px solid #7a3f48;background:#0c1720">
        <small style="color:#ff9c9c;letter-spacing:.12em">RUNTIME.CIRCUIT · BOOTSTRAP STOPPED</small>
        <h1 style="margin:.6rem 0;font:900 clamp(2.5rem,8vw,5.5rem)/.9 system-ui,sans-serif;letter-spacing:-.06em">First Proof did not load</h1>
        <p style="color:#93a7b6">The application module could not start. Local match evidence was not opened or changed.</p>
        <code style="overflow-wrap:anywhere;color:#ffb3b8">${safeMessage}</code>
        <p><button type="button" onclick="location.reload()" style="min-height:44px;padding:.7rem 1rem;border:1px solid #44aeff;color:#eef4fa;background:#101a25">Retry load</button></p>
      </div>
    </div>`;
}

void import("./app-bootstrap").catch(exposeBootstrapFailure);
